<template>
<div>
   <v-dialog v-model="password" width="46rem">
  <div class="container-box" style="background-color:white;padding:5.4rem">
    <!--<div align="middle" class="header-text" v-if="!loading">-->
    <!--<h3>Change Password</h3>-->
    <!--</div>-->
    <div style="height: 30.0rem" class="row" v-if="loading">
      <div class="my-auto mx-auto">
        <v-progress-circular
          :size="70"
          :width="3"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>
    <div v-else>
      <form v-if="hasPassword">
        <div class="popUpH">Change Password</div>
        <div class="cp-10">
          <v-text-field
            ref="Current Password"
            v-model="currentPassword"
            label="Current Password"
            :type="showIcon ? 'password' : 'text'"
            :append-icon="showIcon ? 'visibility_off' : 'visibility'"
            @click:append="showIcon = !showIcon"
            :error-messages="currentPasswordCheck"
            class="input"
            required
          >
          </v-text-field>
        </div>
        <div class="cp-10">
          <v-text-field
            ref="New Password"
            v-model="newPassword"
            label="New Password"
            :type="showIcon2 ? 'password' : 'text'"
            :append-icon="showIcon2 ? 'visibility_off' : 'visibility'"
            @click:append="showIcon2 = !showIcon2"
            :error-messages="newPasswordCheck"
            class="input"
            required
          >
          </v-text-field>
        </div>
        <div class="cp-10">
          <v-text-field
            ref="Cofirm password"
            v-model="repeatPassword"
            label="Confirm New Password"
            :type="showIcon3 ? 'password' : 'text'"
            :append-icon="showIcon3 ? 'visibility_off' : 'visibility'"
            @click:append="showIcon3 = !showIcon3"
            :error-messages="repeatPasswordCheck"
            class="input"
            required
          >
          </v-text-field>
        </div>
        <div style="margin-top: 5.0rem !important" class="row">
          <div @click="updatePasswordSubmit" class="btn btn-save">
            Save New Password
          </div>
          <div class="btn btn-outline" style="margin-left:1rem" @click="emitCancel">
            Cancel
          </div>

        </div>
      </form>
      <!--<div v-else>-->
      <!--<auth-password-->
      <!--v-on:change-password="addPasswordSubmit"-->
      <!--&gt;-->
      <!--</auth-password>-->
      <!--</div>-->
    </div>
    <v-snackbar
      v-model="snackbar"
      :top="y === 'top'"
      :timeout="timeout"
      color="#43A046"
    >
      {{ text }}
      <v-icon color="white" @click="snackbar = false">close</v-icon>
    </v-snackbar>
  </div>
   </v-dialog>
</div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";
import AuthPassword from "./auth-password";
import { UPDATE_PASSWORD } from "../../../Api/common_api";
// import { loadavg } from "os";

export default {
  components: {
    AuthPassword
  },
  data: function() {
    return {
      user: this.$constants.getOwnerInfo(),
      hasPassword: true,
      snackbar: false,
      y: "top",
      timeout: 6000,
      text: "Password Changed Successfully",
      currentPassword: "",
      newPassword: "",
      repeatPassword: "",
      showIcon: true,
      showIcon2: true,
      showIcon3: true,
      wrongPassword: false,
      errorMsg: "",
      loading: false,
      password:false,
    };
  },
  validations: {
    currentPassword: {
      required
    },
    newPassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(12)
    },
    repeatPassword: {
      required,
      sameAs: sameAs("newPassword")
    }
  },
  methods: {
    submit: function(passwordObject, update) {
      const self = this;
      self.loading = true;
      UPDATE_PASSWORD(passwordObject)
        .then(function(response) {
          if (response.status === 200) {
            self.snackbar = true;
            self.currentPassword = "";
            self.newPassword = "";
            self.repeatPassword = "";
            self.$v.$reset();
            self.wrongPassword = false;
            self.loading = false;
            if (update) {
              self.$store.dispatch("signOut").then(function(response) {
                if (response.status === 200 || response.status === 401) {
                  self.$router
                    .push({ name: "landingPage" })
                    .catch(function() {});
                } else {
                  self.loading = false;
                  self.errorMsg = err.response.data.message;
                  self.wrongPassword = true;
                }
              });
            }
          }
        })
        .catch(function(err) {
          if (err.response.status === 400) {
            self.loading = false;
            self.errorMsg = err.response.data.message;
            self.wrongPassword = true;
          }
        });
    },
    open(){
      this.password=true
    },
    updatePasswordSubmit() {
      const self = this;
      self.$v.$touch();
      if (!self.$v.$anyError) {
        let changedPassword = {
          oldPassword: self.currentPassword,
          password: self.repeatPassword
        };
        self.submit(changedPassword);
      }
    },
    addPasswordSubmit(passwordObject) {
      const self = this;
      self.submit(passwordObject, true);
    },
    emitCancel(){
      this.password=false
    }
  },
  computed: {
    currentPasswordCheck: function() {
      const errors = [];
      if (!this.$v.currentPassword.$dirty) return errors;
      !this.$v.currentPassword.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      this.wrongPassword && errors.push(this.errorMsg);
      return errors;
    },
    newPasswordCheck: function() {
      const errors = [];
      if (!this.$v.newPassword.$dirty) return errors;
      !this.$v.newPassword.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      !this.$v.newPassword.maxLength &&
        errors.push(this.$constants.REQUIRED_MESSAGE.PASSWORD_LENGTH);
      !this.$v.newPassword.minLength &&
        errors.push(this.$constants.REQUIRED_MESSAGE.PASSWORD_LENGTH);

      return errors;
    },
    repeatPasswordCheck: function() {
      const errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.required &&
        errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
      !this.$v.repeatPassword.sameAs &&
        errors.push(this.$constants.REQUIRED_MESSAGE.PASSWORD_NOT_MATCH);
      return errors;
    }
  },
  mounted() {
    const self = this;
    self.hasPassword = !!self.user.has_password;
    if (!self.hasPassword)
      self.$router.push({ name: "candidateDashboard" }).catch(function() {});
  }
};
</script>

<style scoped>
.cp-10 {
  padding: 0.5rem 0;
}
.container-box {
  padding: 1rem 2rem;
  width: 100%;
}
.input {
  text-align: right;
  font-size: 1.4rem;
}
</style>
